import { create } from '@thoughtspot/logger';
import { getSortOrderByColId } from '../../../utils/custom-chart-model.utils';
import { validateActionHandlerEventPayloadObject } from './utils';
const logger = create('action-handler-events');
const validateActionHandlerEventPayload = (eventData) => {
    const eventPayload = eventData.payload;
    try {
        validateActionHandlerEventPayloadObject(eventPayload);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
export const getActionHandlerEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateActionHandlerEventPayload(eventData);
        },
        executeEvent: (eventData) => {
            const { actionHandler, chartModel } = props;
            const { eventType, payload } = eventData.payload;
            const columnSortInfo = getSortOrderByColId(chartModel, payload.columnId);
            const actionHandlerFn = actionHandler.get(eventType);
            if (actionHandlerFn) {
                actionHandlerFn('', payload.columnId, payload.isAscending, columnSortInfo);
            }
            return Promise.resolve();
        },
    };
};
//# sourceMappingURL=index.js.map